import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReusableTabsComponent } from './reusable-tabs.component';
import { TabDirective } from './tab.directive';

@NgModule({
  imports: [CommonModule, TabDirective, ReusableTabsComponent],
  exports: [ReusableTabsComponent, TabDirective],
})
export class ReusableTabsModule {}
